import { render, staticRenderFns } from "./ProfileCircle.vue?vue&type=template&id=42052fe0&scoped=true&"
import script from "./ProfileCircle.vue?vue&type=script&lang=js&"
export * from "./ProfileCircle.vue?vue&type=script&lang=js&"
import style0 from "./ProfileCircle.vue?vue&type=style&index=0&id=42052fe0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42052fe0",
  null
  
)

export default component.exports